import { render, staticRenderFns } from "./PortField.vue?vue&type=template&id=444b7ac0&scoped=true"
import script from "./PortField.vue?vue&type=script&lang=ts"
export * from "./PortField.vue?vue&type=script&lang=ts"
import style0 from "./PortField.vue?vue&type=style&index=0&id=444b7ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444b7ac0",
  null
  
)

export default component.exports